// extracted by mini-css-extract-plugin
module.exports = {"headerAndFooterTemplate":"AtHeaderAndFooter_headerAndFooterTemplate__1a7ye"};